import {PopoverOrigin} from '@mui/material';
import React, {useCallback, useMemo, useState} from 'react';

import {EMenu, SubMenuActionsType} from '../EMenu';

export const useButtonMenu = ({
  extraActions,
  onClick,
  disablePortal,
  popoverProps,
}: {
  extraActions?: SubMenuActionsType[];
  onClick?: (evt: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  disablePortal?: boolean;
  popoverProps?: {
    transformOrigin?: PopoverOrigin;
    anchorOrigin?: PopoverOrigin;
  };
}): {
  handleClick: (evt: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  menu: React.ReactElement | null;
} => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleClick = useCallback(
    (evt: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      if (onClick) {
        onClick(evt);
        return;
      }

      if (extraActions && extraActions.length > 0) {
        // if no onClick was defined we open the menu and cancel the event bubbling
        evt.preventDefault();
        evt.stopPropagation();
        setAnchorEl(evt.currentTarget);
      }
    },
    [extraActions, onClick]
  );

  const returnItems = useMemo(
    () => ({
      handleClick,
      menu: onClick ? null : (
        <EMenu
          anchorEl={anchorEl}
          anchorOrigin={
            popoverProps?.anchorOrigin ?? {
              horizontal: 'right',
              vertical: 'bottom',
            }
          }
          disablePortal={disablePortal}
          setAnchorEl={setAnchorEl}
          subActions={extraActions}
          transformOrigin={
            popoverProps?.transformOrigin ?? {
              vertical: 'top',
              horizontal: 'right',
            }
          }
        />
      ),
    }),
    [
      handleClick,
      onClick,
      disablePortal,
      extraActions,
      anchorEl,
      popoverProps?.anchorOrigin,
      popoverProps?.transformOrigin,
    ]
  );
  return returnItems;
};
